import { useTranslation } from 'react-i18next';

export enum LocationOrderStatus {
  DONE = 'done',
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  CANCELLED = 'cancelled',
}

export const useLocationOrderStatusName = (status: string): string => {
  const { t } = useTranslation('locationordersModule');
  switch (status?.toLowerCase()) {
    case LocationOrderStatus.DONE:
      return t('filters.options.status.done');
    case LocationOrderStatus.PENDING:
      return t('filters.options.status.pending');
    case LocationOrderStatus.IN_PROGRESS:
      return t('filters.options.status.in_progress');
    case LocationOrderStatus.CANCELLED:
      return t('filters.options.status.cancelled');
    default:
      return status || t('fallbacks.no_preparation', 'Estado desconocido');
  }
};

export const getLocationOrderStatusColor = (status: string): string => {
  switch (status?.toLowerCase()) {
    case LocationOrderStatus.DONE:
      return 'bg-bg-success text-success';
    case LocationOrderStatus.PENDING:
      return 'bg-badge-bg-status-3 text-badge-status-3';
    case LocationOrderStatus.IN_PROGRESS:
      return 'bg-bg-warning text-warning';
    case LocationOrderStatus.CANCELLED:
      return 'bg-bg-error text-error';
    default:
      return 'bg-badge-bg-status-3 text-badge-status-3';
  }
};
